import { Injectable } from '@angular/core';
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APIResponse } from '../../utils/models/response';
import { Login } from '../models/login';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  apiEndpoint: string = "";
  apiUniqueId: string = 'authenticate/ret/hCw230b862-99250-4f71-a1271-f8bqxvvbner121967d35d/candidate/AOaemvOPybXzswaLnMtcT3gMn3sp3/';
  constructor(
    private httpService: HttpWrapperService,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  validateSignIn(entity: Login): Observable<APIResponse> {
    return this.httpService.post(this.apiEndpoint + 'login', entity).pipe(map((response: APIResponse) => {
      localStorage.setItem('currentUser', JSON.stringify(response.Data));
      return response;
    }));
  }
}
